import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/tools/legacy-score")({
  component: () => <Outlet />,
});